/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconCast from '../../../../../../Icon/IconCast';
import IconCastConnected from '../../../../../../Icon/IconCastConnected';
import IconComputer from '../../../../../../Icon/IconComputer';
import IconDesktopMac from '../../../../../../Icon/IconDesktopMac';
import IconDesktopWindows from '../../../../../../Icon/IconDesktopWindows';
import IconDeveloperBoard from '../../../../../../Icon/IconDeveloperBoard';
import IconDeviceHub from '../../../../../../Icon/IconDeviceHub';
import IconDevicesOther from '../../../../../../Icon/IconDevicesOther';
import IconDock from '../../../../../../Icon/IconDock';
import IconGamepad from '../../../../../../Icon/IconGamepad';
import IconHeadset from '../../../../../../Icon/IconHeadset';
import IconHeadsetMic from '../../../../../../Icon/IconHeadsetMic';
import IconKeyboard from '../../../../../../Icon/IconKeyboard';
import IconKeyboardArrowDown from '../../../../../../Icon/IconKeyboardArrowDown';
import IconKeyboardArrowLeft from '../../../../../../Icon/IconKeyboardArrowLeft';
import IconKeyboardArrowRight from '../../../../../../Icon/IconKeyboardArrowRight';
import IconKeyboardArrowUp from '../../../../../../Icon/IconKeyboardArrowUp';
import IconKeyboardBackspace from '../../../../../../Icon/IconKeyboardBackspace';
import IconKeyboardCapslock from '../../../../../../Icon/IconKeyboardCapslock';
import IconKeyboardHide from '../../../../../../Icon/IconKeyboardHide';
import IconKeyboardReturn from '../../../../../../Icon/IconKeyboardReturn';
import IconKeyboardTab from '../../../../../../Icon/IconKeyboardTab';
import IconKeyboardVoice from '../../../../../../Icon/IconKeyboardVoice';
import IconLaptop from '../../../../../../Icon/IconLaptop';
import IconLaptopChromebook from '../../../../../../Icon/IconLaptopChromebook';
import IconLaptopMac from '../../../../../../Icon/IconLaptopMac';
import IconLaptopWindows from '../../../../../../Icon/IconLaptopWindows';
import IconMemory from '../../../../../../Icon/IconMemory';
import IconMouse from '../../../../../../Icon/IconMouse';
import IconPhoneAndroid from '../../../../../../Icon/IconPhoneAndroid';
import IconPhoneIphone from '../../../../../../Icon/IconPhoneIphone';
import IconPhonelink from '../../../../../../Icon/IconPhonelink';
import IconPhonelinkOff from '../../../../../../Icon/IconPhonelinkOff';
import IconPowerInput from '../../../../../../Icon/IconPowerInput';
import IconRouter from '../../../../../../Icon/IconRouter';
import IconScanner from '../../../../../../Icon/IconScanner';
import IconSecurity from '../../../../../../Icon/IconSecurity';
import IconSimCard from '../../../../../../Icon/IconSimCard';
import IconSmartphone from '../../../../../../Icon/IconSmartphone';
import IconSpeaker from '../../../../../../Icon/IconSpeaker';
import IconSpeakerGroup from '../../../../../../Icon/IconSpeakerGroup';
import IconTablet from '../../../../../../Icon/IconTablet';
import IconTabletAndroid from '../../../../../../Icon/IconTabletAndroid';
import IconTabletMac from '../../../../../../Icon/IconTabletMac';
import IconToys from '../../../../../../Icon/IconToys';
import IconTv from '../../../../../../Icon/IconTv';
import IconVideogameAsset from '../../../../../../Icon/IconVideogameAsset';
import IconWatch from '../../../../../../Icon/IconWatch';

export default function HardwareIcons() {
  return (
    <div>
      <CategoryHeader>hardware</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconCast size="32"/>
          <FigCaption>
            IconCast
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCastConnected size="32"/>
          <FigCaption>
            IconCastConnected
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconComputer size="32"/>
          <FigCaption>
            IconComputer
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDesktopMac size="32"/>
          <FigCaption>
            IconDesktopMac
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDesktopWindows size="32"/>
          <FigCaption>
            IconDesktopWindows
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDeveloperBoard size="32"/>
          <FigCaption>
            IconDeveloperBoard
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDeviceHub size="32"/>
          <FigCaption>
            IconDeviceHub
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDevicesOther size="32"/>
          <FigCaption>
            IconDevicesOther
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDock size="32"/>
          <FigCaption>
            IconDock
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGamepad size="32"/>
          <FigCaption>
            IconGamepad
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHeadset size="32"/>
          <FigCaption>
            IconHeadset
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHeadsetMic size="32"/>
          <FigCaption>
            IconHeadsetMic
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconKeyboard size="32"/>
          <FigCaption>
            IconKeyboard
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconKeyboardArrowDown size="32"/>
          <FigCaption>
            IconKeyboardArrowDown
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconKeyboardArrowLeft size="32"/>
          <FigCaption>
            IconKeyboardArrowLeft
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconKeyboardArrowRight size="32"/>
          <FigCaption>
            IconKeyboardArrowRight
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconKeyboardArrowUp size="32"/>
          <FigCaption>
            IconKeyboardArrowUp
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconKeyboardBackspace size="32"/>
          <FigCaption>
            IconKeyboardBackspace
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconKeyboardCapslock size="32"/>
          <FigCaption>
            IconKeyboardCapslock
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconKeyboardHide size="32"/>
          <FigCaption>
            IconKeyboardHide
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconKeyboardReturn size="32"/>
          <FigCaption>
            IconKeyboardReturn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconKeyboardTab size="32"/>
          <FigCaption>
            IconKeyboardTab
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconKeyboardVoice size="32"/>
          <FigCaption>
            IconKeyboardVoice
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLaptop size="32"/>
          <FigCaption>
            IconLaptop
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLaptopChromebook size="32"/>
          <FigCaption>
            IconLaptopChromebook
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLaptopMac size="32"/>
          <FigCaption>
            IconLaptopMac
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLaptopWindows size="32"/>
          <FigCaption>
            IconLaptopWindows
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMemory size="32"/>
          <FigCaption>
            IconMemory
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMouse size="32"/>
          <FigCaption>
            IconMouse
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhoneAndroid size="32"/>
          <FigCaption>
            IconPhoneAndroid
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhoneIphone size="32"/>
          <FigCaption>
            IconPhoneIphone
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhonelink size="32"/>
          <FigCaption>
            IconPhonelink
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhonelinkOff size="32"/>
          <FigCaption>
            IconPhonelinkOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPowerInput size="32"/>
          <FigCaption>
            IconPowerInput
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRouter size="32"/>
          <FigCaption>
            IconRouter
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconScanner size="32"/>
          <FigCaption>
            IconScanner
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSecurity size="32"/>
          <FigCaption>
            IconSecurity
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSimCard size="32"/>
          <FigCaption>
            IconSimCard
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSmartphone size="32"/>
          <FigCaption>
            IconSmartphone
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSpeaker size="32"/>
          <FigCaption>
            IconSpeaker
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSpeakerGroup size="32"/>
          <FigCaption>
            IconSpeakerGroup
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTablet size="32"/>
          <FigCaption>
            IconTablet
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTabletAndroid size="32"/>
          <FigCaption>
            IconTabletAndroid
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTabletMac size="32"/>
          <FigCaption>
            IconTabletMac
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconToys size="32"/>
          <FigCaption>
            IconToys
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTv size="32"/>
          <FigCaption>
            IconTv
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVideogameAsset size="32"/>
          <FigCaption>
            IconVideogameAsset
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWatch size="32"/>
          <FigCaption>
            IconWatch
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/HardwareIcons.js